import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Extract payment details from URL params or state
  const searchParams = new URLSearchParams(location.search);
  const subscriptionId = searchParams.get("subscription_id");
  const paymentId = searchParams.get("payment_id");

  return (
    <div className="bg-black text-white font-secondary min-h-screen py-16 flex items-center justify-center">
      <div className="max-w-2xl mx-auto text-center px-4">
        {/* Success Icon */}
        <div className="mb-8">
          <svg
            className="w-20 h-20 mx-auto text-green-500"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        <h1 className="font-primary text-4xl uppercase mb-6 text-white">
          Payment Successful!
        </h1>

        <div className="bg-gradient-to-r from-[#0099f2] to-[#1a6dff] rounded-lg p-6 mb-8">
          <h2 className="text-2xl font-bold mb-4">
            Welcome to FOZZIL Blacksite
          </h2>
          <p className="text-lg">
            You now have access to advanced AGI capabilities
          </p>
        </div>

        {paymentId && (
          <div className="bg-gray-900 rounded-lg p-4 mb-6 text-left">
            <h3 className="font-bold mb-2">Payment Details:</h3>
            <p className="text-sm text-gray-300">Payment ID: {paymentId}</p>
            {subscriptionId && (
              <p className="text-sm text-gray-300">
                Subscription ID: {subscriptionId}
              </p>
            )}
          </div>
        )}

        <div className="space-y-4">
          <button
            onClick={() =>
              window.open("https://taels.fozzil.in/", "_blank")
            }
            className="w-full py-3 px-6 bg-gradient-to-r from-[#0099f2] to-[#1a6dff] text-white font-bold rounded-full hover:shadow-lg transition-all duration-300"
          >
            Start Using T.A.E.L.S
          </button>

          <button
            onClick={() => navigate("/")}
            className="w-full py-3 px-6 bg-transparent border border-white text-white font-bold rounded-full hover:bg-white hover:text-black transition-all duration-300"
          >
            Return to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
